import {Component, Input, ViewChild} from '@angular/core';
import {IGameQueryResult} from "../../interfaces/IGameQueryResult";
import {ViewCharityPayoutsComponent} from "./view-charity-payouts/view-charity-payouts.component";
import {AddCharityPayoutsComponent} from "./add-charity-payouts/add-charity-payouts.component";
import {CharityBalancesSummaryComponent} from "./charity-balances-summary/charity-balances-summary.component";
import {ColComponent, ContainerComponent, ListGroupDirective, ListGroupItemDirective, RowComponent} from "@coreui/angular";
import {HasPermissionDirective} from "../../directives/permissions/has-permission";
import {PermissionTypes} from "../../enum/PermissionTypes";

enum ScreenState {
  BalancesSummary,
  ViewPayouts,
  AddPayout
}

@Component({
  selector: 'app-charity-payouts',
  standalone: true,
  templateUrl: './charity-payouts.component.html',
  imports: [
    ViewCharityPayoutsComponent,
    AddCharityPayoutsComponent,
    CharityBalancesSummaryComponent,
    ContainerComponent,
    RowComponent,
    ColComponent,
    ListGroupDirective,
    ListGroupItemDirective,
    HasPermissionDirective
  ],
  styleUrls: ['./charity-payouts.component.scss']
})
export class CharityPayoutsComponent {

  @ViewChild(ViewCharityPayoutsComponent) viewCharityPayoutsComponent!: ViewCharityPayoutsComponent;

  @Input() set gameSetter(gameData: { gameP: IGameQueryResult, isCrossGame: boolean }) {
    // Reset selectedCharityId when game changes
    if (this.activeGame && this.activeGame.Id !== gameData.gameP.Id) {
      this.selectedCharityId = null;
    }
    this.activeGame = gameData.gameP;
  }

  public activeGame: IGameQueryResult | null = null;
  public currentScreenState: ScreenState = ScreenState.BalancesSummary;
  protected readonly ScreenState = ScreenState;
  public selectedCharityId: string | null = null;
  protected readonly permissionTypes = PermissionTypes;

  onPayoutCreated(): void {
    // Refresh the view payouts component if needed
    this.currentScreenState = ScreenState.BalancesSummary;
    this.selectedCharityId = null; // Reset the selected charity
    if (this.viewCharityPayoutsComponent) {
      this.viewCharityPayoutsComponent.fetchCharitiesForGame();
    }
  }

  onMakePayoutClick(charityId: string): void {
    this.selectedCharityId = charityId;
    this.currentScreenState = ScreenState.AddPayout;
  }

  // Reset selected charity when manually navigating to Add Payout tab
  navigateToAddPayout(): void {
    this.selectedCharityId = null;
    this.currentScreenState = ScreenState.AddPayout;
  }
}
